/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Target tassonomico dell\'attributo dichiarato dal bando (align-tipo-pratica-attributo-target-fieldtype, D1)
 */
export enum TargetAttributoDefinizione {

    PRATICA = 'PRATICA',

    ANAGRAFICA_RICHIEDENTE = 'ANAGRAFICA_RICHIEDENTE',

    NUCLEO_FAMILIARE_COMPONENTE = 'NUCLEO_FAMILIARE_COMPONENTE'
}

